import {
    Card,
    Select,
    SelectItem,
    Modal,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Table,
    TableHeader,
    TableColumn,
    TableBody,
    TableRow,
    TableCell,
    DropdownTrigger,
    Button,
    DropdownMenu,
    DropdownItem, Dropdown,
} from '@nextui-org/react'
import RootAdmin from "../../../../components/layouts/RootAdmin";
import React, { useState, useEffect } from 'react';
import ReactMapGL, { Marker, Popup } from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { getFetcher } from '../../../../services/api';
import useSWR from "swr";
import {FunnelIcon} from "@heroicons/react/24/outline";
import ControlledInput from "../../../../components/elements/ControlledInput";
import {useForm} from "react-hook-form";

const ProdusenPeta = () => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [province, setProvince] = useState('');
    const [city, setCity] = useState('');
    const [district, setDistrict] = useState('');
    const [village, setVillage] = useState('');
    const [tipe, setTipe] = useState('bahanb3-produksi')
    const [viewport, setViewport] = useState({
        latitude: -1.3911261987874894,
        longitude: 113.4216565328876,
        zoom: 5,
    });

    // Opsi SWR tanpa fetch otomatis
    const swrOptions = {
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        revalidateIfStale: false,
        revalidateOnMount: false,
        dedupingInterval: 60000,
        suspense: false,
        fallbackData: null,
    };
    const { data: map, mutate: mutateMap } = useSWR(
        `/api/dashboard/pelaporan/Produsen/peta/${tipe}?startDate=${startDate}&endDate=${endDate}&provinceId=${province}&regencyId=${city}&districtId=${district}&villageId=${village}`,
        getFetcher
    );
    const { data: provinces } = useSWR(
        `/api/location/provinces`,
        getFetcher
    );

    const { data: cities, mutate: mutateCities } = useSWR(
        `/api/location/cities?provinceId=${province}`,
        getFetcher,
        swrOptions
    );
    useEffect(() => { // re-fetch everytime province state changes
        setCity('')
        setDistrict('')
        setVillage('')
        if (province !== '') {
            mutateCities();
        }
    }, [province])

    const { data: districts, mutate: mutateDistricts } = useSWR(
        `/api/location/districts?regencyId=${city}`,
        getFetcher,
        swrOptions
    );
    useEffect(() => { // re-fetch everytime city state changes
        setDistrict('')
        setVillage('')
        if (city !== '') {
            mutateDistricts();
        }
    }, [city])

    const { data: villages, mutate: mutateVillages } = useSWR(
        `/api/location/villages?districtId=${district}`,
        getFetcher,
        swrOptions
    );
    useEffect(() => { // re-fetch everytime district state changes
        setVillage('')
        if (district !== '') {
            mutateVillages();
        }
    }, [district])

    const [selectedPoint, setSelectedPoint] = useState(null);

    const handleViewportChange = (newViewport) => {
        setViewport(newViewport);
    };

    function titlePage(data) {
        switch (data) {
            case 'perusahaan-produksi':
                return 'Peta Sebaran Perusahaan Terbanyak Melakukan Produksi';
            case 'perusahaan-pelaporan':
                return 'Peta Sebaran Perusahaan Terbanyak Melakukan Pelaporan';
            case 'bahanb3-produksi':
                return 'Peta Sebaran B3 Terbanyak Diproduksi';
            default:
                return ''
        }
    }

    function renderPopup(data) {
        if (!selectedPoint || data === 'sebaran-bahanb3-province' || data === 'sebaran-bahanb3-regencies') return null;

        switch (data) {
            case 'perusahaan-produksi':
                return (
                    <Popup
                        latitude={selectedPoint.latitude}
                        longitude={selectedPoint.longitude}
                        onClose={() => setSelectedPoint(null)} // Close popup
                        closeButton={true}
                        closeOnClick={false}
                    >
                        <div>
                            <h3>{selectedPoint.name}</h3>
                            <p>{selectedPoint.alamatKantor}</p>
                            <p><strong>Coordinates:</strong> {selectedPoint.latitude}, {selectedPoint.longitude}</p>
                            <p>
                                <strong>{selectedPoint.penanggungJawab}</strong> {selectedPoint.emailKantor}, {selectedPoint.telpKantor}
                            </p>
                            <p><strong>Total Produksi:</strong> {selectedPoint.total}</p>
                        </div>
                    </Popup>
                )
            case 'perusahaan-pelaporan':
                return (
                    <Popup
                        latitude={selectedPoint.latitude}
                        longitude={selectedPoint.longitude}
                        onClose={() => setSelectedPoint(null)} // Close popup
                        closeButton={true}
                        closeOnClick={false}
                    >
                        <div>
                            <h3>{selectedPoint.name}</h3>
                            <p>{selectedPoint.alamatKantor}</p>
                            <p><strong>Coordinates:</strong> {selectedPoint.latitude}, {selectedPoint.longitude}</p>
                            <p>
                                <strong>{selectedPoint.penanggungJawab}</strong> {selectedPoint.emailKantor}, {selectedPoint.telpKantor}
                            </p>
                            <p><strong>Total Pelaporan:</strong> {selectedPoint.total}</p>
                        </div>
                    </Popup>
                )
            case 'bahanb3-produksi':
                return (
                    <Popup
                        latitude={selectedPoint.latitude}
                        longitude={selectedPoint.longitude}
                        onClose={() => setSelectedPoint(null)} // Close popup
                        closeButton={true}
                        closeOnClick={false}
                    >
                        <div>
                            <h3><strong>Nama Bahan Kimia:</strong> {selectedPoint.namaBahanKimia}</h3>
                            <h3><strong>Nomor Cas:</strong> {selectedPoint.casNumber}</h3>
                            <h3><strong>Total Produksi:</strong> {selectedPoint.sum}</h3>
                            <p><strong>Coordinates:</strong> {selectedPoint.latitude}, {selectedPoint.longitude}</p>
                        </div>
                    </Popup>
                )
        }
    }

    const handleFilterDateApply = (start, end) => {
        setStartDate(start);
        setEndDate(end);
        mutateMap(); // Refresh data for peta
    };
    function RenderFilterDate({onApplyFilter}) {
        const { control, watch } = useForm({
            defaultValues: {
                startDate: "",
                endDate: "",
            },
        });
        const filters = watch();

        const handleApply = () => {
            onApplyFilter(filters.startDate, filters.endDate);
        };

        return (
            <Dropdown closeOnSelect={false}>
                <DropdownTrigger>
                    <Button radius='sm' variant='bordered' startContent={<FunnelIcon className='size-4' />}>
                        Saring
                    </Button>
                </DropdownTrigger>
                <DropdownMenu aria-label="Filter Date">
                    <DropdownItem isReadOnly>
                        <ControlledInput
                            name="startDate"
                            label="Tanggal Mulai"
                            type="date"
                            control={control}
                            isRequired
                            rules={{
                                required: "Tanggal Mulai harus diisi.",
                            }}
                        />
                    </DropdownItem>
                    <DropdownItem isReadOnly>
                        <ControlledInput
                            name="endDate"
                            label="Tanggal Selesai"
                            type="date"
                            control={control}
                            isRequired
                            rules={{
                                required: "Tanggal Selesai harus diisi.",
                            }}
                        />
                    </DropdownItem>
                    <DropdownItem isReadOnly>
                        <Button size='sm' color='primary' onClick={handleApply}>
                            Terapkan
                        </Button>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        );
    }

    const filtering = [
        {
            name: 'Sebaran Perusahaan Produksi Terbanyak',
            value: 'perusahaan-produksi'
        },
        {
            name: 'Sebaran Perusahaan Pelaporan Terbanyak',
            value: 'perusahaan-pelaporan'
        },
        {
            name: 'Sebaran B3 Produksi Terbanyak',
            value: 'bahanb3-produksi'
        },
    ]

    return (
        <RootAdmin>
            <Card radius='sm' className='col-span-4 p-3'>
                <div className="w-full h-[600px] z-10">
                    <div className={'flex flex-row justify-between mb-5 items-center w-full'}>
                        <div className={'w-1/2'}>
                            <span className='text-primary text-xl font-bold'>{titlePage(tipe)}</span>
                        </div>

                        <div className={'w-1/3 flex flex-row justify-between items-center gap-5'}>
                            <Select
                                radius="sm"
                                label="Filter"
                                labelPlacement="outside"
                                size="md"
                                placeholder='Pilih filter'
                                value={tipe}
                                defaultSelectedKeys={[tipe]}
                                disallowEmptySelection={true}
                                onChange={(e) => {
                                    setSelectedPoint(null)
                                    setStartDate('')
                                    setEndDate('')
                                    setProvince('')
                                    setCity('')
                                    setDistrict('')
                                    setVillage('')
                                    setTipe(e.target.value)
                                }}
                            >
                                {filtering?.map(item => (
                                    <SelectItem key={item.value} value={item.value}>{item.name}</SelectItem>
                                ))}
                            </Select>
                            <RenderFilterDate onApplyFilter={handleFilterDateApply}/>
                        </div>
                    </div>
                    {tipe.includes("bahanb3") && (<div className={'w-full flex flex-row justify-between gap-3 mb-3'}>
                        <div className={"w-1/4"}>
                            <Select
                                radius="sm"
                                label="Province"
                                labelPlacement="outside"
                                size="md"
                                placeholder='Pilih provinsi'
                                onChange={(e) => {
                                    setSelectedPoint(null)
                                    setProvince(e.target.value)
                                }}
                            >
                                {provinces?.map(item => (
                                    <SelectItem key={item.id} value={item.id}>{item.name}</SelectItem>
                                ))}
                            </Select>
                        </div>
                        <div className={`w-1/4 ${province === '' && 'invisible'}`}>
                            <Select
                                radius="sm"
                                label="Regency"
                                labelPlacement="outside"
                                size="md"
                                placeholder='Pilih kota/kabupaten'
                                onChange={(e) => {
                                    setSelectedPoint(null)
                                    setCity(e.target.value)
                                }}
                            >
                                {cities?.map(item => (
                                    <SelectItem key={item.id} value={item.id}>{item.name}</SelectItem>
                                ))}
                            </Select>
                        </div>
                        <div className={`w-1/4 ${city === '' && 'invisible'}`}>
                            <Select
                                radius="sm"
                                label="District"
                                labelPlacement="outside"
                                size="md"
                                placeholder='Pilih distrik'
                                onChange={(e) => {
                                    setSelectedPoint(null)
                                    setDistrict(e.target.value)
                                }}
                            >
                                {districts?.map(item => (
                                    <SelectItem key={item.id} value={item.id}>{item.name}</SelectItem>
                                ))}
                            </Select>
                        </div>
                        <div className={`w-1/4 ${district === '' && 'invisible'}`}>
                            <Select
                                radius="sm"
                                label="Village"
                                labelPlacement="outside"
                                size="md"
                                placeholder='Pilih desa'
                                onChange={(e) => {
                                    setSelectedPoint(null)
                                    setVillage(e.target.value)
                                }}
                            >
                                {villages?.map(item => (
                                    <SelectItem key={item.id} value={item.id}>{item.name}</SelectItem>
                                ))}
                            </Select>
                        </div>
                    </div>)}
                    <ReactMapGL
                        {...viewport}
                        mapboxAccessToken='pk.eyJ1Ijoic2liMy1rbGhrIiwiYSI6ImNtMms1ZWVrZjAxb3MybHEyajE5cG5zb28ifQ.aCs5cuGJhZqytwo7zlVl5w'
                        mapStyle="mapbox://styles/sib3-klhk/cm3i4eidd00dn01s9809ze69i"
                        onMove={handleViewportChange}
                        dragPan={true}
                        scrollZoom={true}
                        doubleClickZoom={true}
                        touchZoom={true}
                    >
                        {map?.responseData?.map((point,index) => (
                                    <Marker key={index} latitude={point.latitude} longitude={point.longitude}>
                                        <div
                                            onClick={() => {
                                                setSelectedPoint(point)
                                            }}
                                            style={{ cursor: 'pointer', fontSize: '24px' }}
                                        >
                                            📍
                                        </div>
                                    </Marker>
                                ))}

                        {selectedPoint && renderPopup(tipe)}
                    </ReactMapGL>
                </div>
            </Card>
        </RootAdmin>
    );
};
export default ProdusenPeta;
